<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box">
      <b-col md="2" lg="1" order-lg="5" order-md="3" class="text-right">
        <b-button class="btn btn-danger delete-payment" @click.prevent="deletePayment">
          <font-awesome-icon icon="trash-alt" size="xs"></font-awesome-icon>
        </b-button>
      </b-col>
      <b-col md="5" lg="3" order-lg="1" order-md="1">
        <span class="label">Data zaksięgowania</span>
        <span class="value">{{payment.bookedDate | datetime}}</span>
      </b-col>
      <b-col md="5" lg="3" order-lg="2" order-md="2">
        <span class="label">Ilość opłaconych makrocyklów</span>
        <span class="value">{{payment.quantity}}</span>
      </b-col>
      <b-col md="5" lg="3" order-lg="3" order-md="4">
        <span class="label">Typ opłaconego makrocyklu</span>
        <span class="value">{{payment.cycleType | cycleType }}</span>
      </b-col>
      <b-col md="5" lg="2" order-lg="4" order-md="4">
        <span class="label">Wysokość wpłaty</span>
        <span class="value">{{payment.totalPrice | money | replaceDotsWithCommas}}</span>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  padding: 7px;
  margin: 3px;
  background: rgba(0, 0, 0, 0.03);
}
.container-fluid {
  padding: 0px;
}
.delete-payment {
  padding: 3px 10px;
  margin-bottom: 5px;
}
.label {
  font-weight: 600;
}
.value {
  font-style: italic;
  display: block;
  margin-bottom: 10px;
}
</style>
<script>
import moment from "moment";
export default {
  props: ["payment"],
  data() {
    return {};
  },
  methods: {
    deletePayment() {
      this.$emit("delete", this.payment.id);
    },
    moment: function() {
      return moment();
    }
  },

  filters: {
    datetime(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm") : "-";
    },
    money(value) {
      return parseFloat(value).toFixed(2) + " PLN";
    },
    cycleType(value){
      return value == 0 ? 'Standard' : value == 1 ? 'Same rozmowy' : null;
    }
  }
};
</script>
